// src/Lexpromt/services/versionService.js
import {
    db,
    collection,
    addDoc,
    doc,
    getDoc,
    onSnapshot,
    query,
    orderBy,
    where,
    getDocs,
  } from "../firebaseConfig";
  
  const VERSIONS_COLLECTION = "versions";
  
  // Add a new version snapshot
  export async function addVersion(promptId, data) {
    // data: { body, authorId, timestamp }
    const colRef = collection(db, VERSIONS_COLLECTION);
    await addDoc(colRef, { ...data, promptId });
  }
  
  // Subscribe to versions list
  export function subscribeToVersions(promptId, callback) {
    const q = query(
      collection(db, VERSIONS_COLLECTION),
      where("promptId", "==", promptId),
      orderBy("timestamp", "desc")
    );
    return onSnapshot(q, (snapshot) => {
      const list = [];
      snapshot.forEach((snap) => {
        list.push({ id: snap.id, ...snap.data() });
      });
      callback(list);
    });
  }
  
  // Get a specific version by ID
  export async function getVersion(promptId, versionId) {
    const docRef = doc(db, VERSIONS_COLLECTION, versionId);
    const snap = await getDoc(docRef);
    return snap.exists() ? { id: snap.id, data: snap.data() } : null;
  }
  
  // Get the latest version for a prompt
  export async function getLatestVersion(promptId) {
    const q = query(
      collection(db, VERSIONS_COLLECTION),
      where("promptId", "==", promptId),
      orderBy("timestamp", "desc")
    );
    const snap = await getDocs(q);
    for (const docSnap of snap.docs) {
      return { id: docSnap.id, data: docSnap.data() };
    }
    return null;
  }
  